import { useEffect, useRef } from 'react';
import { useGetClockStatusQuery, useClockOutMutation } from '../api/apiSlice';

const IDLE_MS = 2 * 60 * 60 * 1000; // 2 hours — matches backend CLOCK_OUT_IDLE_HOURS default

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'touchmove', 'touchend', 'scroll'];

export function useIdleClockOut() {
  const { data, isSuccess } = useGetClockStatusQuery();
  const [clockOut] = useClockOutMutation();
  const timerRef = useRef(null);

  const isClocked = isSuccess && data?.clock_in_time && !data?.clock_out_time;

  useEffect(() => {
    if (!isClocked) return;

    function resetTimer() {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(clockOut, IDLE_MS);
    }

    resetTimer();
    ACTIVITY_EVENTS.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));

    return () => {
      clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [isClocked, clockOut]);
}
